module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.path.indexOf('_editor') === -1 && _vm.$route.path.indexOf('_wechatlog') === -1 && _vm.$route.path.indexOf('_userlog') === -1) ? _c('div', [_c('el-row', [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.goUrl('/marketing/newCustomer/newCustomer_wechatlog')
      }
    }
  }, [_vm._v("社群记录列表")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.goUrl('/marketing/newCustomer/newCustomer_userlog')
      }
    }
  }, [_vm._v("用户记录列表")])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-input', {
    attrs: {
      "size": "mini",
      "placeholder": "标题"
    },
    model: {
      value: (_vm.params.name),
      callback: function($$v) {
        _vm.$set(_vm.params, "name", $$v)
      },
      expression: "params.name"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "size": "mini",
      "clearable": "",
      "type": "daterange",
      "picker-options": _vm.pickerOptions,
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "align": "right"
    },
    model: {
      value: (_vm.params.times),
      callback: function($$v) {
        _vm.$set(_vm.params, "times", $$v)
      },
      expression: "params.times"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.searchData
    }
  }, [_vm._v("搜索")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.create()
      }
    }
  }, [_vm._v("新增+")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.dataList,
      "height": _vm.wheight - 130
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.type == 1) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v(" 新客专区")]) : _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("社群专区")])]
      }
    }], null, false, 692710789)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "活动标题"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "开始时间",
      "prop": "start_time_text"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "结束时间",
      "prop": "end_time_text"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user_one_limit",
      "label": "参与次数限制"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user_all_limit",
      "label": "活动总人数限制"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.create(scope.row.id)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.del(scope.row.id, scope.$index)
            }
          }
        }, [_vm._v("删除")])]
      }
    }], null, false, 2047756735)
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-center content-top-padded"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "total, sizes, prev, pager, next",
      "current-page": _vm.params.page,
      "page-sizes": [10, 20, 50],
      "total": _vm.total_count,
      "page-size": _vm.params.pagesize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-130988c0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-130988c0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/member/cardticket/newcustomer/list.vue
// module id = 2482
// module chunks = 0